import { render, staticRenderFns } from "./statistic-sumary.vue?vue&type=template&id=15165b42&"
import script from "./statistic-sumary.vue?vue&type=script&lang=js&"
export * from "./statistic-sumary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports